import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Award, Gift, Calendar, Clock, Star, Cake, Users } from "lucide-react";
import { Button } from "../ui/button";

const AccountBenefitsSection = () => {
  const navigate = useNavigate();
  
  const benefits = [
    { icon: Award, title: "Loyalty Rewards", desc: "5 services = 50% OFF, 10 services = FREE!" },
    { icon: Gift, title: "Referral Bonus", desc: "Share your code - both get 15% off!" },
    { icon: Calendar, title: "Easy Booking", desc: "Pre-filled details, faster checkout" },
    { icon: Clock, title: "Booking History", desc: "View past & upcoming appointments" },
    { icon: Star, title: "Exclusive Offers", desc: "Members-only discounts & early access" },
    { icon: Cake, title: "Birthday Rewards", desc: "Special treats on your special day!" }
  ];

  return (
    <section className="section-spacing bg-gradient-to-b from-slate-900 to-slate-950" data-testid="account-benefits-section">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Why Create an <span className="gradient-text">Account?</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Join the RainXpress family and unlock exclusive rewards and easier booking management
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-10">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass rounded-xl p-4 md:p-6 text-center hover:border-cyan-400/30 transition-all"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-cyan-400/10 flex items-center justify-center">
                <benefit.icon className="w-6 h-6 text-cyan-400" />
              </div>
              <h3 className="font-semibold mb-1 text-sm md:text-base">{benefit.title}</h3>
              <p className="text-slate-400 text-xs md:text-sm">{benefit.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <Button 
            onClick={() => navigate('/account')}
            className="btn-primary-glow text-slate-900 font-semibold px-8 py-3 rounded-full"
          >
            <Users className="w-5 h-5 mr-2" />
            Create Free Account
          </Button>
          <p className="text-slate-500 text-sm mt-3">It's free and takes less than a minute</p>
        </div>
      </div>
    </section>
  );
};

export default AccountBenefitsSection;
